import type { EnvironmentId, ModelSelection, ServerProvider } from "@cmmd-forge/contracts";

import { getDefaultServerModel, resolveSelectableProvider } from "../../providerModels";

interface ProviderStatusConfig {
  readonly providers: ReadonlyArray<ServerProvider>;
}

const EMPTY_PROVIDERS: ReadonlyArray<ServerProvider> = [];

export function deriveDraftThreadProviderState(input: {
  readonly activeEnvironmentId: EnvironmentId | null | undefined;
  readonly primaryEnvironmentId: EnvironmentId | null | undefined;
  readonly primaryServerConfig: ProviderStatusConfig | null | undefined;
  readonly activeEnvironmentServerConfig: ProviderStatusConfig | null | undefined;
  readonly draftRouteProviderStatuses?: ReadonlyArray<ServerProvider> | undefined;
  readonly preferredModelSelection?: ModelSelection | null | undefined;
}): {
  readonly providerStatuses: ReadonlyArray<ServerProvider>;
  readonly defaultDraftModelSelection: ModelSelection;
} {
  const serverConfig =
    input.primaryEnvironmentId && input.activeEnvironmentId === input.primaryEnvironmentId
      ? input.primaryServerConfig
      : (input.activeEnvironmentServerConfig ?? input.primaryServerConfig);
  const providerStatuses =
    input.draftRouteProviderStatuses ?? serverConfig?.providers ?? EMPTY_PROVIDERS;
  const defaultDraftProvider = resolveSelectableProvider(
    providerStatuses,
    input.preferredModelSelection?.provider ?? null,
  );
  const preferredModel =
    input.preferredModelSelection?.provider === defaultDraftProvider
      ? input.preferredModelSelection.model
      : null;
  return {
    providerStatuses,
    defaultDraftModelSelection: {
      provider: defaultDraftProvider,
      model: getDefaultServerModel(providerStatuses, defaultDraftProvider, preferredModel),
    },
  };
}
